'use strict';

/**
 * Takes a form submit event and hides the clicked elemnt and shows the promo code form
 *
 * @param {Event} event - Form submit event
 * @returns {void}
 */
const togglePromoCodeDisplay = function (event) {
    if (!event) return;
    const { target } = event;
    const promoCodeForm = document.querySelector('form[name="promo-code-form"]');
    target.classList.add('d-none');
    promoCodeForm.classList.remove('d-none');
};

const init = function () {
    const queryString = `[data-trigger="promo-code"]`;
    const promoCodeTriggers = document.querySelectorAll(queryString);
    if (promoCodeTriggers) {
        promoCodeTriggers.forEach((trigger) =>
            trigger.addEventListener('click', togglePromoCodeDisplay)
        );
    }
};

document.addEventListener("DOMContentLoaded", function () {
    init();
});
